export const getHeaders = (extraHeaders = {}) =>
    new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        ...extraHeaders,
    });
